import { ApiResponseData } from "types/common";
import { useFetchData } from "utils/ReactQueryHooks";

export const usePermission = () =>
  useFetchData({
    key: "permission",
    url: "permissions",
    options: {
      enabled: false,
      select: (data: ApiResponseData) => {
        if (data?.status == "failed") return { status: data.status };
        if (data?.welcome) return data

        return {
          type: data.permissions,
          aId: data.aId,
          userName: data.userName,
          manufacturer: data.manufacturer,
          accountType: data.accountType,
        };
      },
    },
    post: true,
  });
